import React from 'react'
import TrashItem from './TrashItem'

interface TrashItemData {
  id: string
  name: string
  type: 'file' | 'folder'
  size?: number
  mimeType?: string
  modifiedAt: string
  path: string
  deletedAt?: string
}

interface TrashGridViewProps {
  items: TrashItemData[]
  onRestore: (id: string) => void
  onDelete: (id: string) => void
}

const TrashGridView: React.FC<TrashGridViewProps> = ({
  items,
  onRestore,
  onDelete
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pb-12">
      {items.map(item => (
        <TrashItem
          key={item.id}
          id={item.id}
          name={item.name}
          type={item.type}
          size={item.size}
          path={item.path}
          deletedAt={item.deletedAt}
          onRestore={onRestore}
          onDelete={onDelete}
        />
      ))}
    </div>
  )
}

export default TrashGridView